import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_EXTERNAL_ORGANIZATIONS,
  PATH_EXTERNAL_ORGANIZATIONS_NEW,
  PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
} from '../../app/constants/paths.constant';
import { OrganizationForm } from '../../forms/ThirdParty/Organization';
import { FormVariant } from '../../forms';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewExternalOrganizationPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ExternalThirdParties);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'une Organisation")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
            label: 'tiers',
            key: 'externalThirdParties',
          },
          {
            to: PATH_EXTERNAL_ORGANIZATIONS,
            label: 'organisations',
            key: 'externalOrganizations',
          },
          {
            to: PATH_EXTERNAL_ORGANIZATIONS_NEW,
            label: 'nouvelle',
            key: 'newExternalOrganization',
          },
        ]}
      />
      <PageTitle title="Création d'une Organisation" />
      <OrganizationForm
        formVariant={FormVariant.Creation}
        isInternal={false}
        showCancelButton={false}
      />
    </>
  );
};
